import { connect } from 'react-redux';
import { Text } from '@beef/ui-kit';
import { getTariffTitle, getTextColor } from "../../../../store/blocks/tariffs/tariffSelectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    children: getTariffTitle(state),
    color: getTextColor(state),
    size: 'size4-m'
  };
};
export var TariffName = connect(mapStateToProps)(Text);